module.exports = __webpack_public_path__ + "static/media/trash.79b468cd.svg";